import './App.css';
import React, {useState} from 'react';
import Stats from './Stats';
import Logo from './logo.png';
import Social from './Social';
import Topbar from './topbar';
const App = () => {
const [social, showSocial] = useState("Social Media:");
const showMedia = (media) => {
  console.log(media);
  showMedia(media);
}
    return (
      <div className="App">
        <header className="App-header">
        <Topbar />
        <br></br>
        <iframe width="650" height="455"
          src="https://www.youtube.com/embed/3MUs-Aaakdg" title="YouTube video
          player" frameborder="1" allow="accelerometer; autoplay;
          clipboard-write; encrypted-media; gyroscope; picture-in-picture;
          web-share" allowfullscreen></iframe>  
          
        <Social mailMe={social} showSocial={showSocial} />
        


          <table className='container'>
        <thead>
        <tr className='titles'>
        <th>Languages</th>
        <th>Years of Experience</th>
        <th>Projects</th>
        <th>Sites I've Built</th>
        <th>Areas of Expertise</th>
        <th>Certifications</th>
        </tr>
        </thead>
        <tbody>
        <Stats languages="JavaScript, TypeScript, SQL, Rust, C#, C++, Go, Python, Solidity" experience = {4}
         projects= "SCP(Portfolio Project), The Merlin Group, PersonNFT, Go Blockchain, RustChain" sitesBuilt="https://themerlingroupworld.com/, https://samsalgado.github.io/SCP/, https://teaching-technology.netlify.app/"
         adjectives="Manufacturing, Data Analytics, Wellness, Blockchain, Cybersecurity, Education" certifications="JavaScript, React, Solidity, Python, Big Data, Hadoop" />
        </tbody>
        </table>
        </header>
          

        <footer>
        <h2 className='centerfooter'>Project History</h2>
  
     
      <div className='center'>
   
            <a href="https://samsalgado.github.io/SCP/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Portfolio Project </a>
      


          <a href='https://www.themerlingroupworld.com'>The Merlin Group</a>

          <a href='https://github.com/samsalgado/PeopleNFT'>PeopleNFT</a>
            <a href='https://github.com/samsalgado/Go-Blockchain'>Go Blockchain</a>
            <a href='https://github.com/samsalgado/MVC-Store-Database'>ASP.NET Store Build</a>

                 <a href='https://github.com/samsalgado/Rust-Chain'>Rust Chain</a>

                      <a href="https://github.com/samsalgado/Barbershop-Template">Barbershop Template</a>
                       <a href='https://teachingtechnology12.gumroad.com/?_ga=2.128784204.1318804168.1662652584-15204'>Course</a>
                        <a href='https://teaching-technology.netlify.app/'>Teaching Technology Site</a>
                        <a href = "https://samsalgado.github.io/appideas/">App Ideas</a>
                     <a href='https://docs.google.com/document/d/1EpU6cA31-CO7MZ9qAevFG9wMlQtXbiZG/edit?usp=sharing&ouid=109384567562105595029&rtpof=true&sd=true'> Resume</a>



        </div>
        </footer>

        
      </div>
    );
  }

export default App;